/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Checkout/all',[
    'global/all',
    './OnePageCheckout',
    './OrderConfirmation',
    './FreightCollect',
    './PayPal'
], function (Roc, OnePageCheckout, OrderConfirmation, FreightCollect, PayPal) {
    Roc.Logger.debug('Loaded Checkout Module and all dependencies.');

    return {
        OnePageCheckout: OnePageCheckout,
        OrderConfirmation: OrderConfirmation,
        FreightCollect: FreightCollect,
        PayPal: PayPal
    }
});

